<template>
  <div class="content-intro-content" id="identidade-verbal-conteudo-introducao" data-search-anchor>
    <div class="content-intro-description">
      <h1 class="content-title">{{ contentTitle }}</h1>
      <div class="content-description">        
        <p class="content-description-paragraph">{{ contentDescriptionParagraph1 }}</p>
        <p class="content-description-paragraph">{{ contentDescriptionParagraph2 }}</p>
      </div>      
    </div>    
  </div>    
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from '@/mixins/content-page-mixin'
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ContentIntroSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)


   get contentTitle(): string {
    return this.getElementText(1, 0)
  }

  get contentDescriptionParagraph1(): string {
    return this.getElementText(1, 1)
  }

  get contentDescriptionParagraph2(): string {
    return this.getElementText(1, 2)
  }
 
  async getContentPage(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPage()
    }
  }
}
</script>

<style lang="scss">
.content-intro-content {
  display: flex;
  align-items: center;  
  flex-direction: column;
  width: 100%;
}

.content-intro-description {  
  display: grid;
  grid-template-columns: 52% 48%;
  justify-content: space-between;    
  width: 100%;
}

.content-title {  
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  width: 417px;
}

.content-description {
  width: 503px;
}


.content-description-paragraph {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  white-space: pre ;
  
}

.content-description-paragraph:first-of-type {
  margin-top: 0;
}

</style>

